import type {
  BasePortfolioTagResource,
  PublicPortfolioTagResource,
  StudentPortfolioTagResource,
  TeacherPortfolioTagResource,
} from "api/generated";
import type { BaseTag, StudentTag, TeacherTag } from "portfolio/types";

export const baseTagFromDto = (
  resource: BasePortfolioTagResource,
): BaseTag => ({
  id: resource.id,
  parentId: resource.parent_id,
  name: resource.name,
  educationLevels: resource.education_levels.filter(
    (level): level is string => level !== null,
  ),
});

export const studentTagFromDto = (
  resource: StudentPortfolioTagResource,
): StudentTag => baseTagFromDto(resource);

export const teacherTagFromDto = (
  resource: TeacherPortfolioTagResource,
): TeacherTag => ({
  ...baseTagFromDto(resource),
  schoolId: resource.school_id,
  usedInActivitiesAmount: resource.used_in_activities_amount,
  createdAt: new Date(resource.created_at),
  updatedAt: new Date(resource.updated_at),
  meta: {
    archived: resource.meta?.archived,
  },
});

// The public catalogue is a separate table without a hierarchy, so its
// parent_id is always null.
export const publicTagFromDto = (
  resource: PublicPortfolioTagResource,
): BaseTag => baseTagFromDto(resource);

export const tagFromDto = teacherTagFromDto;
